import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
declare const L: any;
import 'leaflet-draw';
import { LatLng } from 'leaflet';
import { get } from 'http';
import { forkJoin } from 'rxjs';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-telco-customer-controller',
  templateUrl: './telco-customer-controller.component.html',
  styleUrls: ['./telco-customer-controller.component.css']
})
export class TelcoCustomerControllerComponent implements OnInit {


  addForm: any | FormGroup
  editForm!: any | FormGroup;

  modelSubtitle = false
  telcoCustomerList: any = [];
  telcoCustomerData: any = []
  objectInfoList: any = []
  locationObjectInfoList: any = []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  first: any = 0
  tableSizes: any = [3, 6, 9, 12];
  cid: any
  isLoading: any = false
  imageUrl: any = ""
  singleObjectInfoData: any = []
  jsonString: string = "";


  actionControls: any = {
    isAdd: false,
    isView: false,
    isDelete: false,
    isModify: false
  }
  branchList: any = [];
  departmentInfoList: any = [];
  locationList: any = [];
  dealerList: any = [];
  id: any;
  recordId: any;
  recordName: any;
  searchFilter: any = "";

  isLatLng: any = false
  private map!: L.Map;
  defaultCenter: any = [17.4065, 78.4772]
  defaultZoom: any = 14
  drawnItems!: L.FeatureGroup;
  objectList: any = []
  serviceData: any = [];

  objectSelectedList: any = [];
  objectDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'assetId',
    textField: 'assetName',
    selectAllText: this.translate.instant('telco-customer-info.multiSelect.selectAll'),
    unSelectAllText: this.translate.instant('telco-customer-info.multiSelect.unSelectAll'),
    itemsShowLimit: 3,
    allowSearchFilter: true
  };


  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private generic_service: GenericService,
    private translate: TranslateService
  ) { }


  ngOnInit(): void {
    let href: any = window.location.href;
    let messages = href.split('/')
    let action: any = this.generic_service.checkActionControls(messages[messages.length - 1])
    this.actionControls = action
    this.cid = sessionStorage.getItem('cid')
    this.getAllTelcoCustomer();
    this.getAllLocation();
    this.getAllBranch();
    this.getAllDepartment_info();
    this.getAllObjectInfo()
    this.getAllIDealerWithoutPagination()
    this.getAllServices()
    this.addForm = this.fb.group({
      customerId: [, [Validators.required]],
      description: [''],
      customerName: ['', [Validators.required]],
      customerPhoneNumber: [, [Validators.required]],
      altPhoneNumber: [],
      customerEmailId: ['', [Validators.required]],
      altEmailId: [''],
      primaryAddress: ['', [Validators.required]],
      customerLocation: ['', [Validators.required]],
      customerBranch: [''],
      customerDepartment: [''],
      buildingProof: [''],
      identityProof: [''],
      photoProof: [''],
      lat: [''],
      lng: [''],
      addressProof: [''],
      serviceInfo: this.fb.array([this.createServiceInfo()]),
      keyValues: this.fb.group({
        key: [''],
        value: ['']
      }),
    });

    this.addForm.get('customerLocation')?.valueChanges.subscribe((selectedZone: string) => {
      console.log('Form changed:', selectedZone);
      this.locationChange(selectedZone);
      const selectedLocation = this.locationList.find((loc: any) => loc.zone === selectedZone);
      if (selectedLocation && this.map) {
        setTimeout(() => {
          if (selectedLocation.lngLat && selectedLocation.lngLat.length > 0) {
            const latLngs = selectedLocation.lngLat.map((coord: any) => L.latLng(parseFloat(coord.y), parseFloat(coord.x)));
            const polygon = L.polygon(latLngs);
            this.map.fitBounds(polygon.getBounds());
            this.map.invalidateSize();
          } else {
            const lat = selectedLocation.lat || selectedLocation.latitude || selectedLocation.y;
            const lng = selectedLocation.lng || selectedLocation.lon || selectedLocation.longitude || selectedLocation.x;
            if (lat && lng) {
              this.map.setView([Number(lat), Number(lng)], 13);
              this.map.invalidateSize();
            }
          }
        }, 100);
      }
    });


    this.editForm = this.fb.group({
      id: [''],
      customerId: [, [Validators.required]],
      description: [''],
      customerName: ['', [Validators.required]],
      customerPhoneNumber: [, [Validators.required]],
      altPhoneNumber: [],
      customerEmailId: ['', [Validators.required]],
      altEmailId: [''],
      primaryAddress: ['', [Validators.required]],
      customerLocation: ['', [Validators.required]],
      customerBranch: [''],
      telcoCustomerId: [''],
      customerDepartment: [''],
      buildingProof: [''],
      identityProof: [''],
      photoProof: [''],
      lat: [''],
      lng: [''],
      addressProof: [''],
      serviceInfo: this.fb.array([this.createServiceInfo()]),
      keyValues: this.fb.group({
        key: [''],
        value: ['']
      }),
    });
  }


  clearFormArray(formArray: FormArray) {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  }

  patchNestedArray(serviceGroup: FormGroup, arrayName: string, items: any[]) {
    const arrayControl = serviceGroup.get(arrayName) as FormArray;
    if (items && items.length > 0) {
      items.forEach((item: any) => {
        const group = this.fb.group({ ...item });
        arrayControl.push(group);
      });
    }
  }

  openEditModal1(customer: any) {

    if (this.map) {
      this.map.remove();
    }
    this.telcoCustomerData = []
    this.telcoCustomerData.push(customer)
    // Clear previous arrays
    this.clearFormArray(this.editForm.get('serviceInfo') as FormArray);

    if (customer.serviceInfo && customer.serviceInfo.length > 0) {
      customer.serviceInfo.forEach((service: any) => {
        const serviceGroup = this.createServiceInfo();
        serviceGroup.patchValue({
          serviceId: service.serviceId,
          serviceName: service.serviceName,
          serviceInfo: service.serviceInfo,
          serviceStatus: service.serviceStatus,
          assetId: service.assetId,
          assetName: service.assetName
        });

        this.patchNestedArray(serviceGroup, 'sipInfo', service.sipInfo);
        this.patchNestedArray(serviceGroup, 'dipInfo', service.dipInfo);
        this.patchNestedArray(serviceGroup, 'dealerInfo', service.dealerInfo);

        (this.editForm.get('serviceInfo') as FormArray).push(serviceGroup);
      });
    } else {
      (this.editForm.get('serviceInfo') as FormArray).push(this.createServiceInfo());
    }
    this.editMapLoad()

    // Patch main fields
    this.editForm.patchValue({
      description: customer.description,
      customerName: customer.customerName,
      customerPhoneNumber: customer.customerPhoneNumber,
      altPhoneNumber: customer.altPhoneNumber,
      customerEmailId: customer.customerEmailId,
      altEmailId: customer.altEmailId,
      primaryAddress: customer.primaryAddress,
      customerLocation: customer.customerLocation,
      customerBranch: customer.customerBranch,
      customerDepartment: customer.customerDepartment,
      buildingProof: customer.buildingProof,
      identityProof: customer.identityProof,
      photoProof: customer.photoProof,
      lat: customer.customerLatLng?.lat,
      lng: customer.customerLatLng?.lng,
      addressProof: customer.addressProof,
      keyValues: {
        key: customer.keyValues?.key,
        value: customer.keyValues?.value
      }
    });

    let latlng = L.latLng(customer.customerLatLng?.lat, customer.customerLatLng?.lng);
    setTimeout(() => {
      this.placeMarkerEdit(latlng);
      console.log(latlng)
    }, 1500);
    console.log(this.editForm.value)
  }

  openEditModal(customer: any) {
    console.log(customer)
    // Open the modal (using jQuery or Bootstrap)
    if (this.map) {
      this.map.remove();
    }
    // Reset the form before patching
    this.editForm.reset();
    this.editMapLoad()
    // Patch all simple values
    this.editForm.patchValue({
      description: customer.description || '',
      customerName: customer.customerName || '',
      customerId: customer.customerId || '',
      customerPhoneNumber: customer.customerPhoneNumber || '',
      altPhoneNumber: customer.altPhoneNumber || '',
      customerEmailId: customer.customerEmailId || '',
      altEmailId: customer.altEmailId || '',
      primaryAddress: customer.primaryAddress || '',
      customerLocation: customer.customerLocation || '',
      customerBranch: customer.customerBranch || '',
      customerDepartment: customer.customerDepartment || '',
      buildingProof: customer.buildingProof || '',
      identityProof: customer.identityProof || '',
      photoProof: customer.photoProof || '',
      addressProof: customer.addressProof || '',
      lat: customer.customerLatLng?.lat || '',
      lng: customer.customerLatLng?.lng || '',
      id: customer.id || '',
      telcoCustomerId: customer.telcoCustomerId || 0
    });

    let latlng = L.latLng(customer.customerLatLng?.lat, customer.customerLatLng?.lng);
    setTimeout(() => {
      this.placeMarkerEdit(latlng);
      console.log(latlng)
    }, 500);

    // Clear and repopulate serviceInfo array
    const serviceArray = this.editForm.get('serviceInfo') as FormArray;
    serviceArray.clear();

    if (customer.serviceInfo && customer.serviceInfo.length > 0) {
      customer.serviceInfo.forEach((service: any) => {
        const serviceGroup = this.createServiceInfo();

        serviceGroup.patchValue({
          serviceId: service.serviceId || '',
          serviceName: service.serviceName || '',
          serviceStatus: service.serviceStatus || '',
          assetId: service.assetId || '',
          extCustomerId: service.extCustomerId || ''

        });


        const assetDetails = serviceGroup.get('assetDetails') as FormArray;
        assetDetails.clear();
        if (service.assetDetails && service.assetDetails.length > 0) {
          service.assetDetails.forEach((asset: any) => {
            assetDetails.push(this.fb.group({
              assetName: [asset.assetName || ''],
              assetId: [asset.assetId || '']
            }));
          });
        }


        // Fill nested SIP info
        const sipArray = serviceGroup.get('sipInfo') as FormArray;
        sipArray.clear();
        if (service.sipInfo && service.sipInfo.length > 0) {
          service.sipInfo.forEach((sip: any) => {
            sipArray.push(this.fb.group({
              sipName: [sip.sipName || ''],
              sipValue: [sip.sipValue || '']
            }));
          });
        }

        // Fill nested DIP info
        const dipArray = serviceGroup.get('dipInfo') as FormArray;
        dipArray.clear();
        if (service.dipInfo && service.dipInfo.length > 0) {
          service.dipInfo.forEach((dip: any) => {
            dipArray.push(this.fb.group({
              dipName: [dip.dipName || ''],
              dipValue: [dip.dipValue || '']
            }));
          });
        }

        // Fill nested Dealer info
        const dealerArray = serviceGroup.get('dealerInfo') as FormArray;
        dealerArray.clear();
        if (service.dealerInfo && service.dealerInfo.length > 0) {
          service.dealerInfo.forEach((dealer: any) => {
            dealerArray.push(this.fb.group({
              dealerName: [dealer.dealerName || ''],
              dealerLocation: [dealer.dealerLocation || '']
            }));
          });
        }

        serviceArray.push(serviceGroup);
      });
    } else {
      // If no service info, ensure at least one empty group
      serviceArray.push(this.createServiceInfo());
    }

    console.log(this.editForm.value)
  }

  onObjectItemSelect(selected: any, index: number) {
    this.assetDetails.at(index).patchValue({
      assetId: selected.objectInfoId,
      assetName: selected.givenName
    });
  }

  get assetDetails(): FormArray {
    return this.addForm.get('assetDetails') as FormArray;
  }

  onObjectSelectAll(items: any, index: any) {
    console.log(items);
  }

  // onObjectSelect(selected: any,index: any) {
  //   const row = this.createAssetDetails();  

  //   row.patchValue({
  //     assetId: selected.objectInfoId,
  //     assetName: selected.givenName
  //   });

  //   this.assetDetails.push(row);         
  // }

  onObjectDeSelect(selected: any, serviceIndex: number) {

    const serviceInfoArray = this.addForm.get('serviceInfo') as FormArray;
    const serviceRow = serviceInfoArray.at(serviceIndex) as FormGroup;

    const assetDetailsArray = serviceRow.get('assetDetails') as FormArray;

    // find the asset row by assetId
    const idx = assetDetailsArray.controls.findIndex(
      x => x.value.assetId === selected.assetId
    );

    if (idx !== -1) {
      assetDetailsArray.removeAt(idx);
    }
  }


  onObjectSelect(selected: any, index: number) {

    console.log(selected)
    // Get the serviceInfo FormArray
    const serviceInfoArray = this.addForm.get('serviceInfo') as FormArray;

    // Get the specific serviceInfo row
    const serviceRow = serviceInfoArray.at(index) as FormGroup;

    // Access assetDetails inside that row
    const assetDetailsArray = serviceRow.get('assetDetails') as FormArray;

    // Create new asset row
    const row = this.createAssetDetails();

    row.patchValue({
      assetId: selected.assetId,
      assetName: selected.assetName
    });

    // Push into assetDetails
    assetDetailsArray.push(row);
  }




  onObjectDeSelectEdit(selected: any, serviceIndex: number) {

    const serviceInfoArray = this.editForm.get('serviceInfo') as FormArray;
    const serviceRow = serviceInfoArray.at(serviceIndex) as FormGroup;

    const assetDetailsArray = serviceRow.get('assetDetails') as FormArray;

    // find the asset row by assetId
    const idx = assetDetailsArray.controls.findIndex(
      x => x.value.assetId === selected.assetId
    );

    if (idx !== -1) {
      assetDetailsArray.removeAt(idx);
    }
  }


  onObjectSelectEdit(selected: any, index: number) {

    console.log(selected)
    // Get the serviceInfo FormArray
    const serviceInfoArray = this.editForm.get('serviceInfo') as FormArray;

    // Get the specific serviceInfo row
    const serviceRow = serviceInfoArray.at(index) as FormGroup;

    // Access assetDetails inside that row
    const assetDetailsArray = serviceRow.get('assetDetails') as FormArray;

    // Create new asset row
    const row = this.createAssetDetails();

    row.patchValue({
      assetId: selected.assetId,
      assetName: selected.assetName
    });

    // Push into assetDetails
    assetDetailsArray.push(row);
  }



  getAllObjectInfo() {
    this.generic_service.getAllObjectInfo().subscribe(
      (response: any) => {
        this.objectInfoList = response.response

        for (let list of this.objectInfoList) {
          list.assetName = list.givenName,
            list.assetId = list.objectInfoId
        }


      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  mapLoad() {
    setTimeout(() => {
      this.initMap();
      this.map.invalidateSize();
    }, 500);
  }

  editMapLoad() {
    setTimeout(() => {
      this.initEditMap();
      // this.map.invalidateSize();
    }, 500);
  }

  viewMapLoad() {
    setTimeout(() => {
      this.initViewMap();
    }, 500);
  }

  marker!: L.Marker;

  private initMap(): void {

    // Initialize the map
    this.map = L.map('map', {
      center: this.defaultCenter,
      zoom: this.defaultZoom
    });

    // Add tile layer
    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 22,
      minZoom: 2,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    });
    tiles.addTo(this.map);

    // Create the drawn items layer group BEFORE using it



    this.map.on('click', (event: L.LeafletMouseEvent) => {
      this.placeMarker(event.latlng);
      console.log(event.latlng)
    });

    tiles.addTo(this.map);
  }

  mapEdit: any; // Leaflet map instance
  mapView: any; // Leaflet map instance
  editMarker: any;

  initViewMap(lat?: number, lng?: number) {

    // Initialize the map
    this.mapView = L.map('mapView', {
      center: this.defaultCenter,
      zoom: this.defaultZoom
    });

    // Add tile layer
    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 22,
      minZoom: 2,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    });
    tiles.addTo(this.mapView);





    const serviceInfo: any[] = this.telcoCustomerData[0]?.serviceInfo || [];
    const objectIds: any[] = serviceInfo
      .flatMap(item => item.assetDetails || [])
      .map(detail => detail.assetId)
      .filter(id => id > 0);


    const customerLatLng: any = {
      lat: Number(this.telcoCustomerData[0]?.customerLatLng.lat),
      lng: Number(this.telcoCustomerData[0]?.customerLatLng.lng)
    }
    console.log(customerLatLng)


    this.loadCustomerMarker(customerLatLng, this.telcoCustomerData[0])
    const latLngPoints: { lat: number, lng: number }[] = [];
    latLngPoints.push({ lat: customerLatLng.lat, lng: customerLatLng.lng });


    if (objectIds.length === 0) {
      setTimeout(() => {
        if (latLngPoints.length === 1) {
          const { lat, lng } = latLngPoints[0];
          this.mapView.setView([lat, lng], 15);
        } else if (latLngPoints.length > 1) {
          const bounds = L.latLngBounds(latLngPoints.map(p => [p.lat, p.lng] as [number, number]));
          this.mapView.fitBounds(bounds, { padding: [50, 50] });
        }

        this.mapView.invalidateSize();
      }, 500);
      return
    }
    console.log(objectIds)

    const requests = objectIds.map(id => this.generic_service.getObjectInfoById(id));

    forkJoin(requests).subscribe(
      (responses: any) => {

        for (const res of responses) {
          if (res.response) {
            const obj = res.response;
            this.objectList.push(obj);

            if (obj.lat && obj.lng) {
              latLngPoints.push({ lat: obj.lat, lng: obj.lng });
              this.loadMarker({ lat: obj.lat, lng: obj.lng }, obj);
            }
          }
        }


        setTimeout(() => {
          if (latLngPoints.length === 1) {
            const { lat, lng } = latLngPoints[0];
            this.mapView.setView([lat, lng], 15);
          } else if (latLngPoints.length > 1) {
            const bounds = L.latLngBounds(latLngPoints.map(p => [p.lat, p.lng] as [number, number]));
            this.mapView.fitBounds(bounds, { padding: [50, 50] });
          }

          this.mapView.invalidateSize();
        }, 500);

        console.log(latLngPoints)





      },
      (err: any) => {
        console.error(err);
        this.toastr.error(err.error?.errors?.[0]?.description || this.translate.instant('telco-customer-info.messages.errorFetchingObject'));

      }
    );



  }

  initEditMap(lat?: number, lng?: number) {
    const defaultLat = lat || 12.9716;
    const defaultLng = lng || 77.5946;

    // If map already exists, remove it before reinitializing
    if (this.mapEdit) {
      this.mapEdit.remove();
    }

    this.mapEdit = L.map('mapEdit').setView([defaultLat, defaultLng], 13);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
    }).addTo(this.mapEdit);

    // Listen for clicks to update marker position
    this.mapEdit.on('click', (e: any) => {
      const coords = e.latlng;
      this.placeMarkerEdit(coords);
    });
  }


  placeMarker(latlng: L.LatLng): void {
    console.log(latlng)
    this.isLatLng = true

    // Remove existing marker if needed
    // this.latlng = latlng
    if (this.marker) {
      this.map.removeLayer(this.marker);
    }

    this.addForm.patchValue({
      lat: latlng.lat,
      lng: latlng.lng

    })

    console.log(this.addForm.value)

    // Create new marker
    this.marker = L.marker(latlng)
      .addTo(this.map)
  }

  placeMarkerEdit(latlng: L.LatLng) {
    if (!this.mapEdit) {
      console.warn('MapEdit not initialized yet');
      return;
    }

    // Remove existing marker
    if (this.editMarker) {
      this.mapEdit.removeLayer(this.editMarker);
    }

    // Add new marker
    this.editMarker = L.marker([latlng.lat, latlng.lng]).addTo(this.mapEdit);

    // Update form coordinates
    this.editForm.patchValue({
      lat: latlng.lat,
      lng: latlng.lng
    });
  }


  removeMark() {
    if (this.marker) {
      this.map.removeLayer(this.marker);
    }

    if (this.editMarker) {
      this.mapEdit.removeLayer(this.editMarker);
    }

    this.editForm.patchValue({
      lat: "",
      lng: ""
    })

    this.addForm.patchValue({
      lat: "",
      lng: ""

    })
  }


  addImageButton(imageButton: any) {
    document.getElementById(imageButton)?.click()
  }

  onImageChange(event: any, image: any, isAddOrEdit: any) {
    const file = event.target.files[0];
    const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];
    if (!validTypes.includes(file.type)) {
      this.toastr.error(this.translate.instant('telco-customer-info.messages.fileTypeNotAllowed'))

      return;
    }
    this.uploadImage(file, image, isAddOrEdit)
  }

  removeIcon(image: any, isAddOrEdit: any) {
    if (isAddOrEdit == "add") {
      if (image == "buildingProof") {
        this.addForm.patchValue({
          buildingProof: ""
        })
      }

      if (image == "identityProof") {
        this.addForm.patchValue({
          identityProof: ""
        })
      }

      if (image == "photoProof") {
        this.addForm.patchValue({
          photoProof: ""
        })
      }

      if (image == "addressProof") {
        this.addForm.patchValue({
          addressProof: ""
        })
      }
    } else {
      if (image == "buildingProof") {
        this.editForm.patchValue({
          buildingProof: ""
        })
      }

      if (image == "identityProof") {
        this.editForm.patchValue({
          identityProof: ""
        })
      }

      if (image == "photoProof") {
        this.editForm.patchValue({
          photoProof: ""
        })
      }

      if (image == "addressProof") {
        this.editForm.patchValue({
          addressProof: ""
        })
      }
    }

  }



  addressProofLoader: any = false
  buildingProofLoader: any = false
  identityProofLoader: any = false
  photoProofLoader: any = false

  uploadImage(file: any, image: any, isAddOrEdit: any) {
    this.addressProofLoader = false
    this.buildingProofLoader = false
    this.identityProofLoader = false
    this.photoProofLoader = false



    if (image == "buildingProof") {
      this.buildingProofLoader = true
    }

    if (image == "identityProof") {
      this.identityProofLoader = true
    }

    if (image == "photoProof") {
      this.photoProofLoader = true
    }

    if (image == "addressProof") {
      this.addressProofLoader = true
    }

    this.generic_service.uploadImage(file).subscribe((response: any) => {
      console.log(response);


      if (isAddOrEdit == 'add') {
        if (image == "buildingProof") {
          this.addForm.patchValue({
            buildingProof: response.response
          })
        }

        if (image == "identityProof") {
          this.addForm.patchValue({
            identityProof: response.response
          })
        }

        if (image == "photoProof") {
          this.addForm.patchValue({
            photoProof: response.response
          })
        }

        if (image == "addressProof") {
          this.addForm.patchValue({
            addressProof: response.response
          })
        }
      } else {
        if (image == "buildingProof") {
          this.editForm.patchValue({
            buildingProof: response.response
          })
        }

        if (image == "identityProof") {
          this.editForm.patchValue({
            identityProof: response.response
          })
        }

        if (image == "photoProof") {
          this.editForm.patchValue({
            photoProof: response.response
          })
        }

        if (image == "addressProof") {
          this.editForm.patchValue({
            addressProof: response.response
          })
        }
      }



    });
  }



  // ---------- Nested Structures ----------

  createServiceInfo(): FormGroup {
    return this.fb.group({
      serviceId: [''],
      extCustomerId: [''],
      serviceName: [''],
      serviceInfo: [''],
      serviceStatus: [''],
      assetId: [''],
      assetName: [''],
      assetDetails: this.fb.array([]),
      sipInfo: this.fb.array([]),
      dipInfo: this.fb.array([]),
      dealerInfo: this.fb.array([])
    });
  }

  getSelectedAssets(serviceIndex: number) {
    const serviceInfo = this.addForm.get('serviceInfo') as FormArray;
    const row = serviceInfo.at(serviceIndex) as FormGroup;

    const assetDetails = row.get('assetDetails') as FormArray;

    return assetDetails.value;  // returns array of { assetId, assetName }
  }

  getSelectedAssetsEdit(serviceIndex: number) {
    const serviceInfo = this.editForm.get('serviceInfo') as FormArray;
    const row = serviceInfo.at(serviceIndex) as FormGroup;

    const assetDetails = row.get('assetDetails') as FormArray;

    return assetDetails.value;  // returns array of { assetId, assetName }
  }


  removeAssetDetails(index: number) {
    this.assetDetails.removeAt(index);
    this.objectSelectedList.splice(index, 1);  // also remove multiselect item tracking
  }

  createAssetDetails(): FormGroup {
    return this.fb.group({
      assetName: [''],
      assetId: ['']
    });
  }

  addAssetDetails() {
    (this.addForm.get('assetDetails') as FormArray).push(this.createAssetDetails());
  }

  createSipInfo(): FormGroup {
    return this.fb.group({
      sipName: [''],
      sipValue: [''],
      keyValueDto: this.fb.array([this.createKeyValue()])
    });
  }

  createDipInfo(): FormGroup {
    return this.fb.group({
      dipName: [''],
      dipValue: [''],
      keyValueDto: this.fb.array([this.createKeyValue()])
    });
  }

  createDealerInfo(): FormGroup {
    return this.fb.group({
      dealerId: [''],
      dealerName: [''],
      dealerLocation: [''],
      keyValueDto: this.fb.array([this.createKeyValue()])
    });
  }

  createKeyValue(): FormGroup {
    return this.fb.group({
      key: [''],
      value: ['']
    });
  }

  // ---------- Getters for easy access ----------
  get serviceInfo(): FormArray {
    return this.addForm.get('serviceInfo') as FormArray;
  }

  addServiceInfo() {
    this.serviceInfo.push(this.createServiceInfo());
  }

  addSipInfo(serviceIndex: number) {
    (this.serviceInfo.at(serviceIndex).get('sipInfo') as FormArray).push(this.createSipInfo());
  }

  addDipInfo(serviceIndex: number) {
    (this.serviceInfo.at(serviceIndex).get('dipInfo') as FormArray).push(this.createDipInfo());
  }

  addDealerInfo(serviceIndex: number) {
    (this.serviceInfo.at(serviceIndex).get('dealerInfo') as FormArray).push(this.createDealerInfo());
  }

  removeSipInfo(serviceIndex: number, sipIndex: number) {
    const sipArray = this.sipInfo(serviceIndex);
    sipArray.removeAt(sipIndex);
  }

  removeDipInfo(serviceIndex: number, dipIndex: number) {
    const dipArray = this.dipInfo(serviceIndex);
    dipArray.removeAt(dipIndex);
  }

  removeDealerInfo(serviceIndex: number, dealerIndex: number) {
    const dealerArray = this.dealerInfo(serviceIndex);
    dealerArray.removeAt(dealerIndex);
  }


  // ---------- Getters for FormArrays ----------

  sipInfo(index: number): FormArray {
    return this.serviceInfo.at(index).get('sipInfo') as FormArray;
  }

  dipInfo(index: number): FormArray {
    return this.serviceInfo.at(index).get('dipInfo') as FormArray;
  }

  dealerInfo(index: number): FormArray {
    return this.serviceInfo.at(index).get('dealerInfo') as FormArray;
  }

  // ---------- Template Helper Methods ----------

  getSipInfoControls(serviceIndex: number) {
    const sipArray = this.sipInfo(serviceIndex);
    return sipArray ? sipArray.controls : [];
  }

  getDipInfoControls(serviceIndex: number) {
    const dipArray = this.dipInfo(serviceIndex);
    return dipArray ? dipArray.controls : [];
  }

  getDealerInfoControls(serviceIndex: number) {
    const dealerArray = this.dealerInfo(serviceIndex);
    return dealerArray ? dealerArray.controls : [];
  }


  // onDealerSelect(index: number) {
  //   const serviceGroup = this.serviceInfo.at(index) as FormGroup;
  //   const selectedAssetId = serviceGroup.get('assetId')?.value;

  //   const selectedAsset = this.objectInfoList.find((a: any) => a.objectInfoId == selectedAssetId);

  //   if (selectedAsset) {
  //     serviceGroup.patchValue({ assetName: selectedAsset.name });
  //   } else {
  //     serviceGroup.patchValue({ assetName: '' });
  //   }
  //   console.log(this.addForm.value)
  // }


  onAssetSelect(index: number) {
    const serviceGroup = this.serviceInfo.at(index) as FormGroup;
    const selectedAssetId = serviceGroup.get('assetId')?.value;

    const selectedAsset = this.objectInfoList.find((a: any) => a.objectInfoId == selectedAssetId);

    if (selectedAsset) {
      serviceGroup.patchValue({ assetName: selectedAsset.name });
    } else {
      serviceGroup.patchValue({ assetName: '' });
    }
    console.log(this.addForm.value)
  }

  onAssetSelectEdit(index: number) {
    const serviceGroup = this.serviceInfoEdit.at(index) as FormGroup;
    const selectedAssetId = serviceGroup.get('assetId')?.value;

    const selectedAsset = this.objectInfoList.find((a: any) => a.objectInfoId == selectedAssetId);

    if (selectedAsset) {
      serviceGroup.patchValue({ assetName: selectedAsset.name });
    } else {
      serviceGroup.patchValue({ assetName: '' });
    }
    console.log(this.editForm.value)
  }


  cancelModel() {
    document.getElementById("closeAddModal")?.click()
    document.getElementById("closeUpdateModal")?.click()
    document.getElementById("closeDeleteModal")?.click()
  }

  onTableDataChange(event: any) {
    this.page = event.page + 1;
  }

  getAllTelcoCustomer() {
    this.isLoading = true

    this.generic_service.getAllTelcoCustomer().subscribe(
      (response: any) => {
        this.telcoCustomerList = response.response;
        this.count = response.response.length;
        console.log(response)
        this.isLoading = false

      }
    )
  }

  closeView() {
    if (this.mapView) {
      this.mapView.remove();
    }
  }

  getTelcoCustomerById(telcoCustomerId: any): void {
    this.telcoCustomerData = [];
    this.objectList = [];
    this.markers = [];

    this.generic_service.getTelcoCustomerById(telcoCustomerId).subscribe(
      (response: any) => {
        const customer = response.response;
        this.telcoCustomerData.push(customer);
        this.viewMapLoad();

        // const serviceInfo: any[] = customer?.serviceInfo || [];
        // const objectIds: any[] = serviceInfo
        //   .filter(item => item.assetId)
        //   .map(item => item.assetId);

        // if (objectIds.length === 0) return;

        // const requests = objectIds.map(id => this.generic_service.getObjectInfoById(id));

        // forkJoin(requests).subscribe(
        //   (responses: any) => {
        //     const latLngPoints: { lat: number, lng: number }[] = [];

        //     for (const res of responses) {
        //       if (res.response) {
        //         const obj = res.response;
        //         this.objectList.push(obj);

        //         if (obj.lat && obj.lng) {
        //           latLngPoints.push({ lat: obj.lat, lng: obj.lng });
        //           this.loadMarker({ lat: obj.lat, lng: obj.lng }, obj);
        //         }
        //       }
        //     }

        //     if (latLngPoints.length > 0) {
        //       const latLngs = latLngPoints.map(item => [item.lat, item.lng] as [number, number]);
        //       const bounds = L.latLngBounds(latLngs);
        //       this.map.fitBounds(bounds, { padding: [20, 20] });
        //       this.map.invalidateSize();
        //     }
        //   },
        //   (err: any) => {
        //     console.error(err);
        //     this.toastr.error(err.error?.errors?.[0]?.description || this.translate.instant('telco-customer-info.messages.errorFetchingObject'));

        //   }
        // );
      },
      (err: any) => {
        console.error(err);
        this.toastr.error(err.error?.errors?.[0]?.description || this.translate.instant('telco-customer-info.messages.errorFetchingCustomer'));

      }
    );
  }



  // Remove existing markers
  private removeMarkers(): void {
    if (!this.mapView) return;
    this.markers.forEach(marker => this.mapView.removeLayer(marker));
    this.markers = [];
  }



  private markers: L.Marker[] = [];

  loadMarker(latLng: { lat: number, lng: number }, list: any): void {
    const iconUrl = list.icon || 'assets/image (1).png';
    const customHtmlIcon = L.divIcon({
      className: '',
      html: `
      <div style="
        position: relative;
        width: 60px;
        height: 60px;
        background: white;
        border: 3px solid #e94141ff;
        border-radius: 50%;
        overflow: hidden;
        box-shadow: 0 2px 6px rgba(0,0,0,0.3);
      ">
        <img src="${iconUrl}" style="width: 100%; height: 100%; object-fit: cover;" />
        <div style="
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          // border-top: 15px solid #2c3e50;
        "></div>
      </div>
    `,
      iconAnchor: [30, 30],
      popupAnchor: [0, 0]
    });

    const marker = L.marker([latLng.lat, latLng.lng], { icon: customHtmlIcon }).addTo(this.mapView)
      .on('click', () => {
        this.singleObjectInfoData = []
        this.singleObjectInfoData.push(list)
        let obj = {
          "Id": this.singleObjectInfoData[0]?.objectInfoId || "",
          "Name": this.singleObjectInfoData[0]?.givenName || "",
          "Condition": this.singleObjectInfoData[0]?.objectCondition || "",
        }
        this.jsonString = JSON.stringify(obj);
        document.getElementById('view-object')?.click()

      });
    this.markers.push(marker);
  }


  loadCustomerMarker(latLng: { lat: number, lng: number }, list: any): void {
    const iconUrl = 'assets/home-icon-illustration-design-vector.jpg';
    const customHtmlIcon = L.divIcon({
      className: '',
      html: `
      <div style="
        position: relative;
        width: 60px;
        height: 60px;
        background: white;
        border: 3px solid #a0d16cff;
        border-radius: 50%;
        overflow: hidden;
        box-shadow: 0 2px 6px rgba(0,0,0,0.3);
      ">
        <img src="${iconUrl}" style="width: 100%; height: 100%; object-fit: cover;" />
        <div style="
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          // border-top: 15px solid #2c3e50;
        "></div>
      </div>
    `,
      iconAnchor: [30, 30],
      popupAnchor: [0, 0]
    });

    const marker = L.marker([latLng.lat, latLng.lng], { icon: customHtmlIcon }).addTo(this.mapView);
    this.markers.push(marker);
  }


  loadObjectMarker(latLng: { lat: number, lng: number }, list: any): void {
    const iconUrl = list.icon || 'assets/image (1).png';
    const customHtmlIcon = L.divIcon({
      className: '',
      html: `
      <div style="
        position: relative;
        width: 60px;
        height: 60px;
        background: white;
        border: 3px solid #a0d16cff;
        border-radius: 50%;
        overflow: hidden;
        box-shadow: 0 2px 6px rgba(0,0,0,0.3);
      ">
        <img src="${iconUrl}" style="width: 100%; height: 100%; object-fit: cover;" />
        <div style="
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          // border-top: 15px solid #2c3e50;
        "></div>
      </div>
    `,
      iconAnchor: [30, 30],
      popupAnchor: [0, 0]
    });

    const marker = L.marker([latLng.lat, latLng.lng], { icon: customHtmlIcon })
      .addTo(this.map).on('click', () => {
        this.removeMark()
        this.singleObjectInfoData = []
        this.singleObjectInfoData.push(list)
        let obj = {
          "Id": this.singleObjectInfoData[0]?.objectInfoId || "",
          "Name": this.singleObjectInfoData[0]?.givenName || "",
          "Condition": this.singleObjectInfoData[0]?.objectCondition || "",
        }
        this.jsonString = JSON.stringify(obj);
        document.getElementById('view-object')?.click()

      });
    this.markers.push(marker);
  }




  imageUrlSelect(url: any) {
    this.imageUrl = url
  }

  closeImage() {
    this.imageUrl = ""
  }


  addTelcoCustomer() {

    if (!this.addForm.valid) {
      this.toastr.error(this.translate.instant('telco-customer-info.messages.fillRequired'));

      return
    }

    console.log(this.addForm.value)

    // let form: any = this.addForm.value

    // for(let list of form){
    //   for(let dealer of list.dealerInfo){
    //     for(let dealerList of this.dealerList){
    //       if(dealer.dealerId == dealerList.dealerId){
    //         dealer.dealerName = dealerList.name
    //       }
    //     }
    //   }
    // }

    let form = this.addForm.value;

    // Create a lookup map for dealerId → dealerName
    const dealerMap = new Map(
      this.dealerList.map((d: any) => [d.dealerId, d.name])
    );

    for (const list of form.serviceInfo) {
      if (!Array.isArray(list.dealerInfo)) continue;

      for (const dealer of list.dealerInfo) {
        const name = dealerMap.get(dealer.dealerId);
        if (name) {
          dealer.dealerName = name;
        }
      }
    }

    console.log(form)


    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "customerName": this.addForm.get('customerName').value,
      "customerId": String(this.addForm.get('customerId').value),
      "customerPhoneNumber": this.addForm.get('customerPhoneNumber').value,
      "altPhoneNumber": 0,
      "customerEmailId": this.addForm.get('customerEmailId').value,
      "altEmailId": "",
      "primaryAddress": this.addForm.get('primaryAddress').value,
      "customerLocation": this.addForm.get('customerLocation').value,
      "customerBranch": this.addForm.get('customerBranch').value,
      "customerDepartment": this.addForm.get('customerDepartment').value,
      "buildingProof": this.addForm.get('buildingProof').value,
      "identityProof": this.addForm.get('identityProof').value,
      "photoProof": this.addForm.get('photoProof').value,
      "addressProof": this.addForm.get('addressProof').value,
      "serviceInfo": this.addForm.get('serviceInfo').value,
      "keyValues": {
        "key": "",
        "value": ""
      },
      "customerLatLng": {
        "lat": this.addForm.get('lat').value,
        "lng": this.addForm.get('lng').value
      },
      "cid": this.cid
    }

    console.log(body)
    this.generic_service.addTelcoCustomer(body).subscribe(
      (response: any) => {
        this.cancelModel()
        this.addForm.reset()
        this.clearForm()
        this.getAllTelcoCustomer()
        this.toastr.success(response.message);
      },
      (err: any) => {
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      }
    )

  }

  updateTelcoCustomer() {
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "id": this.editForm.get('id').value,
      "customerId": this.editForm.get('customerId').value,
      "telcoCustomerId": this.editForm.get('telcoCustomerId').value,
      "customerName": this.editForm.get('customerName').value,
      "customerPhoneNumber": this.editForm.get('customerPhoneNumber').value,
      "altPhoneNumber": 0,
      "customerEmailId": this.editForm.get('customerEmailId').value,
      "altEmailId": "",
      "primaryAddress": this.editForm.get('primaryAddress').value,
      "customerLocation": this.editForm.get('customerLocation').value,
      "customerBranch": this.editForm.get('customerBranch').value,
      "customerDepartment": this.editForm.get('customerDepartment').value,
      "buildingProof": this.editForm.get('buildingProof').value,
      "identityProof": this.editForm.get('identityProof').value,
      "photoProof": this.editForm.get('photoProof').value,
      "addressProof": this.editForm.get('addressProof').value,
      "serviceInfo": this.editForm.get('serviceInfo').value,
      "keyValues": {
        "key": "",
        "value": ""
      },
      "customerLatLng": {
        "lat": this.editForm.get('lat').value,
        "lng": this.editForm.get('lng').value
      },
      "cid": this.cid
    }

    console.log(body)
    this.generic_service.updateTelcoCustomer(body).subscribe(
      (response: any) => {
        this.cancelModel()
        this.editForm.reset()
        this.clearForm()
        this.getAllTelcoCustomer()
        this.toastr.success(response.message);
      },
      (err: any) => {
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      }
    )

  }




  // ---------- Form Reset ----------

  clearForm(): void {
    this.addForm.reset({
      version: 0,
      isActive: true,
      description: '',
      id: '',
      telcoCustomerId: 0,
      customerName: '',
      customerPhoneNumber: 0,
      altPhoneNumber: 0,
      customerEmailId: '',
      altEmailId: '',
      primaryAddress: '',
      customerLocation: '',
      customerBranch: '',
      customerDepartment: '',
      buildingProof: '',
      identityProof: '',
      photoProof: '',
      addressProof: '',
      serviceInfo: [],
      keyValues: { key: '', value: '' },
      cid: 0
    });

    // Explicitly clear FormArrays
    this.serviceInfo.clear();
  }

  // ---------- Submit Handler ----------

  onSubmit(): void {
    if (this.addForm.valid) {
      console.log('✅ Form Submitted:', this.addForm.value);
      this.toastr.success(this.translate.instant('telco-customer-info.messages.formSubmitted'));

    } else {
      console.warn('⚠️ Invalid form data');
      this.addForm.markAllAsTouched();
    }
  }

  getAllServices() {
    this.generic_service.getAllServices().subscribe(
      (response: any) => {
        this.serviceData = response.response;
        console.log(response)
      }
    )
  }

  getAllLocation() {
    this.generic_service.getAllLocation().subscribe(
      (response: any) => {
        this.locationList = response.response
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  getAllBranch() {
    this.generic_service.getBranch().subscribe(
      (response: any) => {
        this.branchList = response.response;
      }
    )
  }

  getAllIDealerWithoutPagination() {
    this.generic_service.getAllIDealerWithoutPagination().subscribe(
      (res: any) => {
        console.log(res)
        this.dealerList = res.response
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  getAllDepartment_info() {
    this.generic_service.getAllDepartment_info().subscribe(
      (response: any) => {
        this.departmentInfoList = response.response
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  clearData() {
    this.recordId = "";
    this.recordName = "";
  }

  telcoCustomerSoftDelete() {
    this.generic_service.telcoCustomerSoftDelete(this.id).subscribe(
      (response: any) => {
        this.toastr.success(response.message)
        this.getAllLocation();
        this.cancelModel();
        this.getAllTelcoCustomer()
        this.clearData()
      },
      (err: any) => {
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  deleteIdSelect(id: any, list: any) {
    this.id = id
    this.recordId = list.telcoCustomerId
    this.recordName = list.customerName
  }


  getTelcoCustomerByWildSearch() {
    if (this.searchFilter == "" || this.searchFilter == null) {
      this.getAllTelcoCustomer();
      return
    }
    this.isLoading = true;
    this.generic_service.getTelcoCustomerByWildSearch(this.searchFilter).subscribe(
      (res: any) => {
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.telcoCustomerList = []
          this.count = 0
          this.isLoading = false;
          return

        }
        this.telcoCustomerList = res.response
        this.count = res.response.length
        this.isLoading = false;
      },
      (err: any) => {
        console.log(err);
        this.isLoading = false;
      }
    );
  }








  get serviceInfoEdit(): FormArray {
    return this.editForm.get('serviceInfo') as FormArray;
  }

  addServiceInfoEdit() {
    this.serviceInfoEdit.push(this.createServiceInfo());
  }

  addSipInfoEdit(serviceIndex: number) {
    (this.serviceInfoEdit.at(serviceIndex).get('sipInfo') as FormArray).push(this.createSipInfo());
  }

  addDipInfoEdit(serviceIndex: number) {
    (this.serviceInfoEdit.at(serviceIndex).get('dipInfo') as FormArray).push(this.createDipInfo());
  }

  addDealerInfoEdit(serviceIndex: number) {
    (this.serviceInfoEdit.at(serviceIndex).get('dealerInfo') as FormArray).push(this.createDealerInfo());
  }

  removeSipInfoEdit(serviceIndex: number, sipIndex: number) {
    const sipArray = this.sipInfoEdit(serviceIndex);
    sipArray.removeAt(sipIndex);
  }

  removeDipInfoEdit(serviceIndex: number, dipIndex: number) {
    const dipArray = this.dipInfoEdit(serviceIndex);
    dipArray.removeAt(dipIndex);
  }

  removeDealerInfoEdit(serviceIndex: number, dealerIndex: number) {
    const dealerArray = this.dealerInfoEdit(serviceIndex);
    dealerArray.removeAt(dealerIndex);
  }


  // ---------- Getters for FormArrays ----------

  sipInfoEdit(index: number): FormArray {
    return this.serviceInfoEdit.at(index).get('sipInfo') as FormArray;
  }

  dipInfoEdit(index: number): FormArray {
    return this.serviceInfoEdit.at(index).get('dipInfo') as FormArray;
  }

  dealerInfoEdit(index: number): FormArray {
    return this.serviceInfoEdit.at(index).get('dealerInfo') as FormArray;
  }

  // ---------- Template Helper Methods ----------

  getSipInfoControlsEdit(serviceIndex: number) {
    const sipArray = this.sipInfoEdit(serviceIndex);
    return sipArray ? sipArray.controls : [];
  }

  getDipInfoControlsEdit(serviceIndex: number) {
    const dipArray = this.dipInfoEdit(serviceIndex);
    return dipArray ? dipArray.controls : [];
  }

  getDealerInfoControlsEdit(serviceIndex: number) {
    const dealerArray = this.dealerInfoEdit(serviceIndex);
    return dealerArray ? dealerArray.controls : [];
  }



  locationChange(loc: any) {
    this.removeMark()
    this.locationObjectInfoList = []
    const requests = this.generic_service.getAllByLocationAndCid(loc)

    const latLngPoints: { lat: number, lng: number }[] = [];

    forkJoin(requests).subscribe(
      (responses: any) => {
        for (const res of responses) {
          if (res.response != null) {
            this.locationObjectInfoList.push(...res.response);
          }
          for (let list of this.locationObjectInfoList) {

            if (list.multiLatLng) {
              if (list.area && list.area != null && list.area.lenght != 0) {
                this.loadObjectPolyline(list.area, list)
              }
            } else {
              if (list.lat && list.lat != null && list.lat != '' && list.lat != '0' && list.lat != 0) {
                const objectLatLng: any = {
                  lat: list.lat,
                  lng: list.lng
                }
                this.loadObjectMarker(objectLatLng, list)
                latLngPoints.push({ lat: objectLatLng.lat, lng: objectLatLng.lng });
              }
            }


          }
        }
      },
      (err: any) => {
        console.log(err);
      }
    );

    setTimeout(() => {
      if (latLngPoints.length === 1) {
        const { lat, lng } = latLngPoints[0];
        this.map.setView([lat, lng], 15);
        this.map.invalidateSize();
      } else if (latLngPoints.length > 1) {
        const latLngs = latLngPoints.map(item => [item.lat, item.lng] as [number, number]);
        const bounds = L.latLngBounds(latLngs);

        // Move map to center and adjust zoom to fit
        this.map.fitBounds(bounds, { padding: [50, 50] });

        // Ensure map redraws properly
        this.map.invalidateSize();
      }
    }, 1500);

  }


  loadObjectPolyline(latlngs: { lat: number, lng: number }[], list: any): void {


    // Default styling for the polyline
    const defaultOptions = {
      color: list.objectColorCode || 'black',
      weight: 6,
      opacity: 0.8,
    };

    // Create the polyline
    const polyline = L.polyline(latlngs, defaultOptions).addTo(this.map);

    // Zoom the map to fit the polyline bounds
    this.map.fitBounds(polyline.getBounds());

    // Optional: add a click event on the polyline
    polyline.on('click', () => {
      this.removeMark()
      console.log('ok')
      this.singleObjectInfoData = []
      this.singleObjectInfoData.push(list)
      let obj = {
        "Id": this.singleObjectInfoData[0]?.objectInfoId || "",
        "Name": this.singleObjectInfoData[0]?.givenName || "",
        "Condition": this.singleObjectInfoData[0]?.objectCondition || "",
      }
      this.jsonString = JSON.stringify(obj);
      document.getElementById('view-object')?.click()
    }
    );
  }

}
